import { connect } from 'react-redux'
import CancelGroupOrderModal from '@components/groupOrders/CancelGroupOrderModal'
import coordinators from '@coordinators'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService } = services
  const {
    CancelGroupOrder,
    CancelAndRefundAllSubOrders,
    GetEstimatedChefPayoutsFromCancelledGroupOrder,
    GetGroupOrderActiveSubOrders,
  } = coordinators

  const cancelGroupOrder = CancelGroupOrder({
    RestService,
    HandleError,
  })
  const cancelAndRefundAllSubOrders = CancelAndRefundAllSubOrders({
    RestService,
    HandleError,
  })
  const getEstimatedChefPayouts =
    GetEstimatedChefPayoutsFromCancelledGroupOrder({
      RestService,
      HandleError,
    })
  const getGroupOrderActiveSubOrders = GetGroupOrderActiveSubOrders({
    RestService,
    HandleError,
  })

  return {
    cancelGroupOrder,
    cancelAndRefundAllSubOrders,
    getEstimatedChefPayouts,
    getGroupOrderActiveSubOrders,
  }
}

export default connect(undefined, mapDispatchToProps)(CancelGroupOrderModal)
